import { __awaiter } from "tslib";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37a5997b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { name: "staking-amount" };
const _hoisted_2 = { class: "desc" };
const _hoisted_3 = { class: "crypto-stake" };
const _hoisted_4 = { class: "crypto-stake-is" };
const _hoisted_5 = { class: "bold-green" };
const _hoisted_6 = { class: "crypto-stake-is" };
const _hoisted_7 = { class: "crypto-stake-is" };
const _hoisted_8 = { class: "interest-rates" };
const _hoisted_9 = { class: "add-space" };
const _hoisted_10 = { class: "modified-text bold-green" };
const _hoisted_11 = { class: "deposit-input-field" };
const _hoisted_12 = ["disabled"];
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
import InputFieldWithSideBtnVue from '@/materials/molecules/InputFieldWithSideBtn.vue';
import WanrList from '@/materials/molecules/WarnList.vue';
import { useStaking } from '@/logics/staking';
import { useMessage } from '@/const/messages';
import { ref, onMounted } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        cryptoName: null,
        term: null,
        cryptoId: null,
        stakeAmount: null,
        isAuth: { type: Boolean }
    },
    emits: ["onConfirm"],
    setup(__props, { emit }) {
        return __awaiter(this, void 0, void 0, function* () {
            let __temp, __restore;
            const props = __props;
            const disabled = ref(false);
            const errMsg = ref([]);
            const list = ref();
            const { STAKING, PLANCARD, format } = useMessage();
            const { getStakingPlanListsByTerm, getStakingPlanListsByTermUnlogin, getPlanFromList } = useStaking();
            if (props.isAuth) {
                list.value = (([__temp, __restore] = _withAsyncContext(() => getStakingPlanListsByTerm(props.cryptoId, props.cryptoName, props.term))),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            else {
                list.value = (([__temp, __restore] = _withAsyncContext(() => getStakingPlanListsByTermUnlogin(props.cryptoId, props.cryptoName, props.term))),
                    __temp = yield __temp,
                    __restore(),
                    __temp);
            }
            const amount = props.stakeAmount !== 0 ? ref(props.stakeAmount) : ref(list.value.minStake);
            const FREE_PLAN = 1;
            onMounted(() => {
                if (list.value.maxStake < list.value.minStake) {
                    disabled.value = true;
                }
            });
            const onClickStake = () => {
                if (!disabled.value) {
                    errMsg.value = [];
                    if (amount.value > list.value.maxStake) {
                        errMsg.value = [format(STAKING.MAX_STAKE)];
                    }
                    if (amount.value < list.value.minStake) {
                        errMsg.value = [format(STAKING.MIN_STAKE)];
                    }
                    if (Number.isNaN(amount.value)) {
                        errMsg.value = [format(STAKING.INPUT_STAKE)];
                        return;
                    }
                    if (errMsg.value.length > 0) {
                        return;
                    }
                    emit('onConfirm', amount.value, getPlanFromList(amount.value, list.value.plan), list.value.calculationDecimalPart);
                }
            };
            const setAmount = (value) => {
                amount.value = value;
            };
            const reInit = () => {
                if (errMsg.value.length > 0) {
                    errMsg.value = [];
                }
            };
            onMounted(() => {
                if (list.value.maxStake < list.value.minStake) {
                    disabled.value = true;
                }
            });
            return (_ctx, _cache) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(STAKING).ENTER)), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                            _createVNode(CryptoIcon, {
                                class: "crypto_icon",
                                base: __props.cryptoName,
                                width: 50
                            }, null, 8, ["base"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKING).PERIOD)), 1),
                                _createElementVNode("div", _hoisted_5, _toDisplayString(list.value.term === FREE_PLAN ? _unref(format)(_unref(PLANCARD).PLAN) : list.value.term + _unref(format)(_unref(PLANCARD).DAY)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKING).QUANTITY)), 1),
                                _createElementVNode("div", null, _toDisplayString(list.value.minStake), 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKING).AMOUNT)), 1),
                                _createElementVNode("div", null, _toDisplayString(list.value.maxStake), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(STAKING).ANNUAL_INTEREST)), 1),
                                _createElementVNode("div", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value.plan, (plan) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: plan.id,
                                            class: "rates"
                                        }, [
                                            _createTextVNode(_toDisplayString(plan.boundaryAmount) + " ", 1),
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(props.cryptoName) + " ~", 1),
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(plan.annualInterestRate) + "%", 1)
                                        ]));
                                    }), 128))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(InputFieldWithSideBtnVue, {
                                    label: props.cryptoName.toUpperCase(),
                                    "initialize-amount": _unref(amount),
                                    "min-input": list.value.minStake,
                                    "max-input": list.value.maxStake,
                                    step: list.value.step,
                                    decimal: list.value.calculationDecimalPart,
                                    disabled: disabled.value,
                                    onSetAmount: setAmount,
                                    onKeyPress: reInit
                                }, null, 8, ["label", "initialize-amount", "min-input", "max-input", "step", "decimal", "disabled"])
                            ]),
                            _createVNode(WanrList, { message: errMsg.value }, null, 8, ["message"]),
                            (disabled.value)
                                ? (_openBlock(), _createBlock(WanrList, {
                                    key: 0,
                                    message: [_unref(format)(_unref(STAKING).DISABLED_MSG)]
                                }, null, 8, ["message"]))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                onClick: onClickStake,
                                class: _normalizeClass(disabled.value ? 'act-btn btn-disabled' : 'act-btn'),
                                disabled: disabled.value
                            }, _toDisplayString(_unref(format)(_unref(STAKING).BTN)), 11, _hoisted_12)
                        ])
                    ])
                ]));
            };
        });
    }
});
